/**
 * User menu module
 *
 * 열고 닫기는 공용 팝오버 등록부를 지난다: 다른 메뉴(알림 벨·언어)를 열면 이 메뉴가
 * 닫히고, 바깥 클릭과 Esc 도 등록부의 캡처 리스너 한 벌이 처리한다 (예전에는 자체
 * 문서 리스너였는데, 벨 트리거의 stopPropagation 에 막혀 서로 닫히지 않았다).
 */
import { openExclusive, closedExclusive } from './popover-registry.js';

export function toggleUserMenu(event) {
    if (event) event.stopPropagation();
    const menu = document.getElementById('userMenuDropdown');
    if (!menu) return;

    if (menu.classList.contains('show')) {
        closeUserMenu();
    } else {
        openUserMenu();
    }
}

export function openUserMenu() {
    const menu = document.getElementById('userMenuDropdown');
    if (!menu) return;

    menu.classList.add('show');
    openExclusive('user-menu', closeUserMenu, { roots: [menu, '.user-menu-trigger'] });
}

export function closeUserMenu() {
    closedExclusive('user-menu');
    const menu = document.getElementById('userMenuDropdown');
    if (menu) {
        menu.classList.remove('show');
    }
}

// Make functions available globally for onclick handlers
window.toggleUserMenu = toggleUserMenu;
window.openUserMenu = openUserMenu;
window.closeUserMenu = closeUserMenu;
